import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const RefreshIcon = (props: IconProps) => (
  <ChakraIcon viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
  </ChakraIcon>
)

export default RefreshIcon
